module.exports = __webpack_public_path__ + "img/linkdin.a780e5cf.png";